<template>
  <div id="orderPosClientScreen" @click="goFullScreen">
    
      <template v-if="company_id == 201">
        <div class="backgroungImg"
            v-if="loading"
            style="background-image: url('static/img/background/posBg_201.png')"
            ></div>
      </template>
      <template v-else>
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
      </template>
    
    <div class="row orderView" v-if="!loading">
      <div class=" col-lg-12 col-md-12 pad-to-15">
        <table class="table orders-table">
          <thead>
              <tr>
                <th>{{$t('orders.name')}}</th>
                <th>{{$t('orders.qty')}}</th>
                <th>{{$t('orders.unit')}}</th>
                <th>{{$t('orders.total')}}</th>
              </tr>
          </thead>
          <tbody>
            <template v-for="customer in order.people">
              <tr v-if="order.order_type=='GROUP'" class="active"><td colspan="4">{{$t('customers.single')}}: {{customer.customer_name}}</td></tr>
              <tr v-for="prod in customer.products">
                <td>
                  {{prod.name}}
                  <p v-if="prod.extra" style="margin: 0;">{{prod.extra}}</p>
                  <div v-if="prod.additional_info != ''" class="pad-to-10"><span >{{$t('orders.custComments')}}: <i class="text-danger">{{prod.additional_info}}</i></span></div>
                </td>
                <td>{{prod.quantity}}</td>
                <td>{{formatMoneyAmount(prod.price_unit, currency)}}</td>
                <td><b>{{formatMoneyAmount(parseFloat(prod.quantity) * parseFloat(prod.price), currency)}}</b></td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="clearfix"> </div>
        <div class="row">
          <div class="col-md-5"></div>
          <div class="col-md-7">
            <table class="table no-border totals-table">
              <tbody>
                <template v-for="label of order.order_totals">
                  <template  v-if="(label != 'totals_grandtotal' && label != 'totals_shipping')">
                    <tr v-if="label.value > 0">
                      <td>
                        <span v-if="label.name == 'totals_extras'">{{$t('orders.' + label.name)}}</span>
                        <span v-else>{{label.name}}</span>
                        <!-- <span v-show="label == 'totals_discount'">(Coupon: {{coupon}})</span> -->
                      </td>
                      <td class="text-right">
                        {{formatMoneyAmount(label.value, currency, true)}}
                      </td>
                    </tr>
                  </template>
                </template>
                <tr>
                  <td>
                    <span>{{$t('orders.totals_grandtotal')}}</span>
                  </td>
                  <td class="text-right">
                    {{formatMoneyAmount(order.total_order_price, currency, true)}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="bacsisView" v-if="!loading && bacsisView && order.use_tips">
      <!-- <div class="bacsisTitle">
        <h3>Adauga Bacsis:</h3>
      </div> -->
      <!-- <div class="bacsisBtns">
        <button class="btn btn-fill btn-info" @click="addTip(5)">5%</button>
        <button class="btn btn-fill btn-info" @click="addTip(10)">10%</button>
        <button class="btn btn-fill btn-info" @click="addTip(20)">20%</button>
      </div> -->
      <div class="tipsBox">
        <div class="tipsInputsTitle">
          <span>{{$t('addOrder.addTip')}}</span>
        </div>
        <div class="tipsBoxCollpase">
          <div class="tipsInputs">
            <div class="col col-zero"
                @click="addTip(0)">
              <img src="/static/img/icons/sad.png">
              <span> 0%</span>
            </div>
            <div class="col col-one"
                @click="addTip(5)">
              <img src="/static/img/icons/smile.png">
              <span> +5%</span>
            </div>
            <div class="col col-two"
                @click="addTip(10)">
              <img src="/static/img/icons/star.png">
              <span> +10%</span>
            </div>
            <div class="col col-three"
                @click="addTip(15)">
              <img src="/static/img/icons/love.png">
              <span> +15%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        loading: true,
        bacsisView: false,
        isFullScreen: false,
        currency: '',
        timeoutGetOrder: null,
        bacsisViewTimeout: null,
        company_id: null,
        order: {}
      }
    },
    created: function () {
      this.company_id = this.$session.get('selectedCompany')
      this.order = JSON.parse(localStorage.getItem('order_for_' + this.company_id))
      this.getCompanyDetail('currency')
      this.getOrder()
    },
    beforeDestroy () {
      this.stopGetOrder()
    },
    methods: {
      stopGetOrder () {
        clearInterval(this.timeoutGetOrder)
      },
      getOrder () {
        clearInterval(this.timeoutGetOrder)
        this.timeoutGetOrder = setInterval(() => {
          this.order = JSON.parse(localStorage.getItem('order_for_' + this.company_id))
          this.loading = true
          // clearTimeout(this.bacsisViewTimeout)
          // this.bacsisView = false
          if (this.order && this.order.people) {
            for (var i = this.order.people.length - 1; i >= 0; i--) {
              if (this.order.people[i].products.length) {
                this.loading = false
                this.bacsisViewTimeout = setTimeout(() => {
                  this.bacsisView = true
                }, 5000)
              }
            }
          }
        }, 500)
      },
      addTip (proc) {
        let tip = this.order.total_order_price * (proc / 100)
        localStorage.setItem('order_for_' + this.company_id + '_add_tip', JSON.stringify(tip))
      },
      goFullScreen () {
        var element = document.querySelector('#orderPosClientScreen')
        this.requestFullScreen(element)
        // if (this.isFullScreen) {
        //   // document.exitFullscreen()
        //   // this.isFullScreen = false
        // } else {
        //   this.isFullScreen = true
        //   this.requestFullScreen(element)
        // }
      },
      requestFullScreen (element) {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
        if (requestMethod) { // Native full screen.
          requestMethod.call(element)
        } else if (typeof window.ActiveXObject !== 'undefined') { // Older IE.
          var wscript = new ActiveXObject('WScript.Shell')
          if (wscript !== null) {
            wscript.SendKeys('{F11}')
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .backgroungImg {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
  }
  #orderPosClientScreen {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    padding: 20px;
    background-color: white;
    color: black;
  }
  .orderView {
    width: 100%;
    height: 70%;
    overflow: auto;
  }
  .bacsisView {
    width: 100%;
    height: 30%;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .tipsBox {
    border-top: 1px solid #DFDFDF;
    .tipsInputsTitle {
      font-size: 18px;
      font-weight: 600;
      text-align: left;
      margin: 0 20px;
      padding-top: 10px;
      // color: green;
      // span {
      //   text-decoration: underline;
      // }
    }
    .custom-tip-input {
      margin-bottom: 10px;
    }
    .tipsInputs {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
      .col {
          cursor: pointer;
          background: #fff;
          padding: 7px;
          border-radius: 50px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 110px;
          border: 1px solid #DFDFDF;
          font-size: 18px;
          font-weight: 600;
          margin: 10px;
          img {
            max-width: 27px;
          }
      }
      .col.selected {
        background: var(--addBtnColor);
        color: var(--addBtnColorInv);
      }
      .col.disabled {
        opacity: 0.3;
        user-select: none;
        pointer-events: none;
      }
    }
    .tipsInputs.disabled {
        opacity: 0.3;
        user-select: none;
        pointer-events: none;
    }
    .custom-tip-input {
      input {
        border-radius: 50px;
        font-size: 14px;
        height: 43px;
        padding: 5px 20px;
        margin: 5px 0px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
      button {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        height: 43px;
        padding: 10px 20px;
        font-size: 15px;
        font-weight: 500;
        width: 95px;
      }
    }
    .custom-tip-input.disabled {
      opacity: 0.3;
      user-select: none;
      pointer-events: none;
    }
    .tips {
      font-size: 18px;
      background: transparent;
      color: green;
      text-decoration: underline;
      padding-top: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/OrdersPos/OrderPosClientScreen.vue